import React, { useEffect } from 'react';
import { BulkChangeDatesFormButtons } from './bulk-change-dates-form-buttons';
import {
  FormEvent,
  FormStatus,
  Reservation,
  bulkAvailableRateQuery,
  bulkAvailableService,
} from '@lib/state';
import { ErrorDisplay } from '../forms';
import { LoadingIndicator } from './loading-indicator';
import { BulkActivitiesDisplay } from './bulk-activities-display';
import { BulkActivityType, availableRatesToReservationRows } from './bulk-change-utils';
import { useObservable } from '../utils';

interface Props {
  propertyId: string;
  corporateAccountId: string;
  selectedReservations: Reservation[];
  formEvents: FormEvent;
  checkInDate?: Date;
  checkOutDate?: Date;
}

export const BulkChangeDatesPanel: React.FC<Props> = ({
  propertyId,
  corporateAccountId,
  selectedReservations,
  formEvents,
  checkInDate,
  checkOutDate,
}) => {
  const bulkAvailability = useObservable(bulkAvailableRateQuery.bulkAvailableRates);

  useEffect(() => {
    bulkAvailableService.getBulkAvailability(
      propertyId,
      corporateAccountId,
      selectedReservations,
      checkInDate,
      checkOutDate
    );
  }, [propertyId, corporateAccountId, selectedReservations, checkInDate, checkOutDate]);

  return (
    <>
      <BulkChangeDatesFormButtons
        propertyId={propertyId}
        corporateAccountId={corporateAccountId}
        bulkAvailability={bulkAvailability}
        reservations={selectedReservations}
        checkInDate={checkInDate}
        checkOutDate={checkOutDate}
        disabled={formEvents.status !== FormStatus.Initial || selectedReservations.length === 0}
      />
      <ErrorDisplay error={formEvents.error} />
      {formEvents.status === FormStatus.Pending && (
        <LoadingIndicator loadingText="Applying changes..." />
      )}
      <BulkActivitiesDisplay
        data={availableRatesToReservationRows(bulkAvailability, selectedReservations)}
        checkInDate={checkInDate}
        checkOutDate={checkOutDate}
        bulkActivityType={BulkActivityType.ChangeDates}
      />
    </>
  );
};
